import { render, staticRenderFns } from "./StandingOrderDrug.vue?vue&type=template&id=28710be0&scoped=true&"
import script from "./StandingOrderDrug.vue?vue&type=script&lang=js&"
export * from "./StandingOrderDrug.vue?vue&type=script&lang=js&"
import style0 from "./StandingOrderDrug.vue?vue&type=style&index=0&id=28710be0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28710be0",
  null
  
)

export default component.exports